<template>
  <history-template>
    <template #histories>
      <template v-for="history in histories">
        <hc-command-comment
          v-if="history.type === HISTORY.TYPE.COMMENT"
          :key="history.id"
          :vbComment="history.comment"
        >
        </hc-command-comment>

        <hc-commands-common-create-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.TAO_MOI"
          :key="history.id"
          :actionLog="history.actionLog"
        ></hc-commands-common-create-action-log>

        <hc-commands-common-update-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.CAP_NHAT"
          :key="history.id"
          :actionLog="history.actionLog"
          :hcCaseCommandsId="hcCaseCommandsId"
        ></hc-commands-common-update-action-log>

        <hc-commands-bao-cao-action-log
          v-else-if="
            history.actionName === ACTION_LOG_ACTION_NAME.BAO_CAO_TIEN_DO ||
              history.actionName ===
                ACTION_LOG_ACTION_NAME.BAO_CAO_HOAN_THANH ||
              history.actionName === ACTION_LOG_ACTION_NAME.BAO_TRUNG_CHI_DAO
          "
          :key="history.id"
          :actionLog="history.actionLog"
        ></hc-commands-bao-cao-action-log>

        <hc-commands-ycbs-action-log
          v-else-if="
            history.actionName === ACTION_LOG_ACTION_NAME.YEU_CAU_BO_SUNG
          "
          :key="history.id"
          :actionLog="history.actionLog"
        ></hc-commands-ycbs-action-log>

        <hc-commands-gia-han-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.GIA_HAN"
          :key="history.id"
          :actionLog="history.actionLog"
        ></hc-commands-gia-han-action-log>

        <hc-commands-gia-han-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.PHE_DUYET_GIA_HAN"
          :key="history.id"
          :actionLog="history.actionLog"
        ></hc-commands-gia-han-action-log>

        <hc-commands-dk-deadline-action-log
          v-else-if="
            history.actionName === ACTION_LOG_ACTION_NAME.DANG_KY_DEADLINE
          "
          :key="history.id"
          :actionLog="history.actionLog"
        ></hc-commands-dk-deadline-action-log>

        <hc-commands-huy-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.HUY_YEU_CAU"
          :key="history.id"
          :actionLog="history.actionLog"
        ></hc-commands-huy-action-log>

        <hc-commands-phe-duyet-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.PHE_DUYET"
          :key="history.id"
          :actionLog="history.actionLog"
        ></hc-commands-phe-duyet-action-log>

        <hc-commands-cho-y-kien-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.CHO_Y_KIEN"
          :key="history.id"
          :actionLog="history.actionLog"
        ></hc-commands-cho-y-kien-action-log>
      </template>
    </template>

    <template #footer>
      <hc-command-comment-input
        :hcCaseCommandsId="hcCaseCommandsId"
        :hcType="hcType"
        @commentSuccess="commentSuccess"
      ></hc-command-comment-input>
    </template>
  </history-template>
</template>

<script>
import vbCommentService from "../../../services/vbCommentService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import HcCommandComment from "./hc-command-comment";
import HcCommandCommentInput from "./hc-command-comment-input";
import HistoryTemplate from "./history-template";
import actionLogService from "../../../services/actionLogService";
import h from "../../../services/h";
import HcCommandsCommonCreateActionLog from "./hc-commands-common-create-action-log";
import constants from "../../../constants";
import HcCommandsCommonUpdateActionLog from "./hc-commands-common-update-action-log";
import HcCommandsBaoCaoActionLog from "./hc-commands-bao-cao-action-log";
import HcCommandsYcbsActionLog from "./hc-commands-ycbs-action-log";
import HcCommandsGiaHanActionLog from "./hc-commands-gia-han-action-log";
import HcCommandsDkDeadlineActionLog from "./hc-commands-dk-deadline-action-log";
import HcCommandsHuyActionLog from "./hc-commands-huy-action-log";
import HcCommandsPheDuyetActionLog from "./hc-commands-phe-duyet-action-log";
import HcCommandsChoYKienActionLog from "./hc-commands-cho-y-kien-action-log";

export default {
  name: "hc-commands-history",
  mixins: [handleRequestErrorMixin],
  props: ["hcCaseCommandsId", "hcCaseCommandsCommonId","hcType"],
  components: {
    HcCommandComment,
    HcCommandCommentInput,
    HcCommandsChoYKienActionLog,
    HcCommandsPheDuyetActionLog,
    HcCommandsHuyActionLog,
    HcCommandsDkDeadlineActionLog,
    HcCommandsGiaHanActionLog,
    HcCommandsYcbsActionLog,
    HcCommandsBaoCaoActionLog,
    HcCommandsCommonUpdateActionLog,
    HcCommandsCommonCreateActionLog,
    HistoryTemplate,
    VuePerfectScrollbar
  },
  filters: {},

  data() {
    return {
      isFullScreen: true,
      actionLogs: null,
      histories: [],
      comments: [],
      ACTION_LOG_ACTION_NAME: constants.ACTION_LOG_ACTION_NAME.CHI_DAO,
      HISTORY: constants.HISTORY
    };
  },

  watch: {},
  computed: {},

  created() {
    this.reloadHistories();
  },

  methods: {
    commentSuccess({ vbComment }) {
      this.comments.push(vbComment);
      this.populateHistories();
    },

    async reloadHistories() {
      await this.loadActionLogs();
      await this.loadComments();
      this.populateHistories();
    },

    loadActionLogs() {
      return actionLogService
        .findAllForHcCaseCommands(
          this.hcCaseCommandsId,
          this.hcCaseCommandsCommonId
        )
        .then(response => (this.actionLogs = response.data));
    },

    loadComments() {
      return vbCommentService
        .findAllHcCommandComments(
          { objectId: this.hcCaseCommandsId },
          { sort: "createTime,desc" }
        )
        .then(response => {
          this.comments = response.data;
        });
    },

    populateHistories() {
      let histories = [];

      h.each(this.actionLogs, actionLog => {
        histories.push({
          id: actionLog.id,
          type: constants.HISTORY.TYPE.ACTION_LOG,
          createTime: actionLog.createTime,
          actionName: actionLog.actionName,
          actionLog: actionLog
        });
      });

      h.each(this.comments, comment => {
        histories.push({
          id: comment.id,
          type: constants.HISTORY.TYPE.COMMENT,
          createTime: comment.createTime,
          comment: comment
        });
      });

      //sap xep lại theo thời gian
      histories.sort((node1, node2) => node2.createTime - node1.createTime);

      this.histories = histories;
    }
  }
};
</script>

<style scoped>
.full-screen {
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 100%;
}

.half-screen {
  width: 75%;
  max-width: 420px;
  transition: 0.5s;
}

@keyframes half-to-full {
  from {
    width: 75%;
  }
  to {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-commands-history.vue